
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9 1a2 2 0 00-2 2v1H3a1 1 0 000 2h1v14a3 3 0 003 3h10a3 3 0 003-3V6h1a1 1 0 100-2h-4V3a2 2 0 00-2-2H9zm6 3H9V3h6v1zM8 6h10v14a1 1 0 01-1 1H7a1 1 0 01-1-1V6h2zm3 5a1 1 0 10-2 0v5a1 1 0 102 0v-5zm3-1a1 1 0 011 1v5a1 1 0 11-2 0v-5a1 1 0 011-1z"}})])
          )
        }
      }
    